import { Popover } from "@material-ui/core";
import { Block, Delete } from "@material-ui/icons";
import React from "react";

import { Button } from "../../ui/chakra/components/Button";
import { ChakraUIThemeProviderForMigration } from "../../ui/chakraUiMigration/theme/ChakraUIThemeProviderForMigration";

import type { UserMessage } from "@spwn/types/firebase/firestore";

type Props = {
  target: React.RefObject<HTMLElement>;
  banTargetComment: Pick<UserMessage, "_id" | "uid"> | undefined;
  disableUserBlock: boolean;
  onClose: () => void;
  onClickBanUser: (comment: Pick<UserMessage, "_id" | "uid">) => Promise<void>;
  onClickBanComment: (idx: string) => Promise<void>;
};

// 管理者によるコメント削除前の確認ダイアログ
export const StreamingCommentBanDialog: React.FC<Props> = (props) => {
  if (!props.banTargetComment) return null;

  return (
    <Popover
      open={!!props.banTargetComment}
      onBackdropClick={props.onClose}
      anchorEl={props.target.current}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <div
        style={{
          padding: "8px 4px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ChakraUIThemeProviderForMigration>
          <Button
            size={"sm"}
            variant={"outline"}
            disabled={props.disableUserBlock}
            onClick={async () => {
              if (!props.banTargetComment) return;
              await props.onClickBanUser(props.banTargetComment);
              props.onClose();
            }}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "16px",
            }}
          >
            <Block />
            <span style={{ marginLeft: "8px" }}>ユーザーブロック</span>
          </Button>
          <Button
            size={"sm"}
            variant={"outline"}
            onClick={async () => {
              if (!props.banTargetComment?._id) return;
              await props.onClickBanComment(props.banTargetComment._id);
              props.onClose();
            }}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "16px",
            }}
          >
            <Delete />
            <span style={{ marginLeft: "8px" }}>コメント削除</span>
          </Button>
        </ChakraUIThemeProviderForMigration>
      </div>
    </Popover>
  );
};
